/**
 * A/B-Wrapper der Hauptnavigation (RED-12851).
 *
 * Je ausgelieferter Variante liegt ein Slot `.navigation-variante[data-variante]` als direktes Kind im DOM. Sichtbar
 * ist genau der Slot, dessen Name im Attribut `variante` steht; alle anderen tragen `hidden`. Kameleoon (oder die
 * Admin-Vorschau) schaltet über das Attribut oder `zeigeVariante(name)` um. Beides wirkt auch, wenn es vor dem
 * Upgrade des Custom Elements passiert: `attributeChangedCallback` läuft beim Upgrade für vorhandene Attribute nach.
 */
class MainNavigationAbWrapper extends HTMLElement {
    static get observedAttributes() {
        return ['variante'];
    }

    attributeChangedCallback(name, alterWert, neuerWert) {
        if (name !== 'variante' || alterWert === neuerWert) {
            return;
        }
        if (!this.aktualisiereSichtbarkeit(neuerWert) && alterWert !== null) {
            // Kein Slot zur gewünschten Variante (nicht ausgeliefert oder Tippfehler): Attribut auf den letzten
            // gültigen Wert zurücksetzen, damit es den sichtbaren Slot widerspiegelt und die Navigation nie verschwindet.
            this.setAttribute('variante', alterWert);
        }
    }

    /**
     * Macht die Variante `name` sichtbar (z. B. 'megamenue'). Unbekannte oder nicht ausgelieferte Varianten werden
     * ignoriert.
     */
    zeigeVariante(name) {
        this.setAttribute('variante', name);
    }

    /**
     * Zeigt den Slot zur Variante und versteckt alle anderen.
     * @returns {boolean} true, wenn ein Slot zur Variante existiert
     */
    aktualisiereSichtbarkeit(variante) {
        const slots = Array.from(this.querySelectorAll(':scope > .navigation-variante'));
        const ziel = slots.find(slot => slot.dataset.variante === variante);
        if (!ziel) {
            return false;
        }
        slots.forEach(slot => {
            slot.hidden = slot !== ziel;
        });
        return true;
    }
}

if (!customElements.get('main-navigation-ab-wrapper')) {
    customElements.define('main-navigation-ab-wrapper', MainNavigationAbWrapper);
}
